import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppPageHeader from "@/components/app/AppPageHeader.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import NearestReminders from "@/components/reminders/NearestReminders.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


const store = useStore()

const isAuthenticated = computed(() => store.getters["auth/isAuthenticated"])

return (_ctx: any,_cache: any) => {
  return (!_unref(isAuthenticated))
    ? (_openBlock(), _createBlock(AppPageHeader, { key: 0 }, {
        default: _withCtx(() => [
          _createTextVNode("Your calendar")
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(AppPageHeader, null, {
          default: _withCtx(() => [
            _createTextVNode("Your life")
          ]),
          _: 1
        }),
        _createVNode(NearestReminders)
      ], 64))
}
}

})